<template>
    <div>
        <header-one/>
        <content-app/>
        <footer-component/>
    </div>
</template>

<script>
    import ContentApp from "../../components/ContentApp";
    // import HeaderComponent from "../component/HeaderComponent";
    import FooterComponent from "../component/FooterComponent";
    import HeaderOne from "../component/HeaderOne";
    export default {
        name: "index",
        components:{
            HeaderOne,
            FooterComponent,
            ContentApp
        },
        data(){
          return {
              show: false
          }
        },
        created() {
        }
    }
</script>

<style scoped>

</style>